import classNames from 'classnames';

import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';

import './AssetImageContainer.scss';

const AssetImageContainer: FCC<{ className?: string; rounded?: boolean; circle?: boolean }> = ({
  children,
  className = '',
  rounded = true,
  circle = false,
}) => (
  <div
    className={classNames(
      `asset-image-container ${className}`,
      {
        ['asset-image-container--rounded']: rounded,
      },
      {
        ['asset-image-container--circle']: circle,
      }
    )}>
    <>{children}</>
  </div>
);

export { AssetImageContainer };
